import { useOutletContext } from 'react-router-dom';
import type { LeadRecord } from '@flashpoint/site-dna';

export function useLeadOutlet(): { lead: LeadRecord } {
  return useOutletContext<{ lead: LeadRecord }>();
}
